import API from 'services/API';

export default function getPersonalStatus() {
  return API.request({
    method: 'GET',
    url: '/profile/personalStatus',
    mapper: function (data) {
      return data;
    },
  });
}
